import MiniButton from "../../components/MiniButton";
import PolylineIcon from "@mui/icons-material/Polyline";
import { colorsList } from "../../data/colorsList";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateIcon from "@mui/icons-material/Create";
import { isEditor } from "../../functions/isEditor";

export default function LimitButton({
  iconSize,
  shadow,
  style,
  onClick,
  iconColor,
  color,
  boundaryInfo,
  deleteClick,
  drawClick,
}) {
  return (
    <div>
      <MiniButton
        Icon={PolylineIcon}
        iconColor={iconColor}
        onClick={onClick}
        color={color}
        iconSize={iconSize}
        shadow={shadow}
        style={{
          ...style,
        }}
      />
      {isEditor && (
        <div
          style={{
            position: "relative",
            overflow: "hidden",
            //backgroundColor: "green",
            height:
              boundaryInfo.active &&
              (boundaryInfo.data?.id || boundaryInfo.isEmpty)
                ? 40
                : 0,
            width: 55,
            transition: "height 0.5s",
          }}
        >
          <MiniButton
            Icon={boundaryInfo.isEmpty ? CreateIcon : DeleteIcon}
            onClick={boundaryInfo.isEmpty ? drawClick : deleteClick}
            color={boundaryInfo.isEmpty ? colorsList.green : colorsList.red}
            iconSize={20}
            shadow={true}
            style={{
              position: "absolute",
              opacity:
                boundaryInfo.isEmpty && !boundaryInfo.createActive ? 0.5 : 1,
              width: 45,
              bottom: 7,
            }}
          />
        </div>
      )}
    </div>
  );
}
